import React from 'react'
import { Grid } from '@mui/material'
import { ArrayInputLogicPrice } from 'src/components/pages/sales/business-rule/logic/contentRule/ArrayInputLogicPrice'

export const ContentRuleComponent = ({record}) => {
  return (
    <>
      <Grid container spacing={3}>
        <ArrayInputLogicPrice record={record} />
      </Grid>
    </>
  )
}
